import { MAX_SMS_VALUE_COUNT } from '@constants/common';

export const maxLengthProps = text => ({
  dateProps: { maxLength: MAX_SMS_VALUE_COUNT },
  helperInfoText: `${text ? text.length : 0}/${MAX_SMS_VALUE_COUNT}`,
});

export default {};
